import './index.css'
import React from 'react'

import { DatePicker } from '@progress/kendo-react-dateinputs'
import classNames from 'classnames'

const DocumentEffectiveDate = ({ id, value, onChange, className, ...rest }) => { 
  return (
    <DatePicker
      format={'dd MMM, yyyy'}
      placeholder = " "
      defaultValue={value ? new Date(value) : null}
      className={classNames('default-datepicker-wrapper', className)}
      onChange={e => onChange(e, id)}
      {...rest}
    />
  )
}

export default DocumentEffectiveDate
